import { AxiosResponse } from 'axios';

import { PATH } from '@/shared/constants';
import { serverAxios } from '@/shared/api';
import { CollectionListSnakeCase } from '@/shared/types';

export interface CollectionFilterApiResponse {
  [key: string]: {
    name: string;
    filter: string[];
  };
}

export interface CollectionListApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CollectionListSnakeCase[];
}

interface CollectionSearchApiParams {
  page?: number;
  pageSize?: number;
  chip?: string[];
  search?: string;
  ordering?: string;
}

export const collectionTagApi = async () => {
  return await serverAxios.get<CollectionFilterApiResponse>(
    PATH.COLLECTION_FILTER_TAG
  );
};

export const collectionSearchApi = async ({
  chip,
  search,
  page = 1,
  pageSize = 16,
  ordering,
}: CollectionSearchApiParams) => {
  return await serverAxios.get<CollectionListApiResponse>(
    '/yozmit/collections/',
    {
      params: {
        page,
        chip,
        search,
        page_size: pageSize,
        ordering,
      },
      paramsSerializer: (params) => {
        const urlSearchParams = new URLSearchParams();
        Object.keys(params).forEach((key) => {
          const paramsValue = params[key];

          if (!paramsValue) return;

          if (key === 'chip') {
            const isDefaultChip = paramsValue.toString() === 'popular';

            if (isDefaultChip) {
              urlSearchParams.append('ordering', paramsValue.toString());
            } else {
              paramsValue.forEach((v: string) =>
                urlSearchParams.append(key, v)
              );
            }
          } else {
            urlSearchParams.append(key, paramsValue);
          }
        });

        return urlSearchParams.toString();
      },
    }
  );
};

interface AdvertiseCollectionApiParams {
  location: 'editor_choice' | 'hot_1' | 'hot_2';
}

interface AdvertiseCollectionApiResponse {
  id: number;
  collection: CollectionListSnakeCase;
  location: string;
}

const DEFAULT_EMPTY_COLLECTION: AdvertiseCollectionApiResponse = {
  id: 0,
  collection: {
    id: 0,
    title: 'NO_AD',
    scraps: [],
    like_count: 0,
    view_count: 0,
    scrapped_count: 0,
    thumbnail: '',
    thumbnail_main_color: '',
    is_public: false,
    profile: {
      id: 0,
      image: '',
      name: '',
      role: '',
      role_kor: '',
    },
  },
  location: '',
};

export const advertiseCollectionApi = async ({
  location,
}: AdvertiseCollectionApiParams) => {
  try {
    return await serverAxios.get<AdvertiseCollectionApiResponse>(
      '/yozmit/collections/advertisement/',
      {
        params: {
          location,
        },
      }
    );
  } catch (error) {
    return (await {
      data: DEFAULT_EMPTY_COLLECTION,
    }) as AxiosResponse<AdvertiseCollectionApiResponse>;
  }
};

export const recommendMyCollectionApi = async () => {
  return await serverAxios.get<CollectionListApiResponse>(
    '/yozmit/collections/my/',
    {
      params: {
        page_size: 5,
      },
    }
  );
};

export const getMyCollectionsApi = () => {
  return serverAxios.get<CollectionListApiResponse>('/yozmit/collections/my/', {
    params: {
      // TODO: 내컬렉션 리스트 조회 api, 배포이후 인피니티 스크롤 적용
      page_size: 999,
    },
  });
};
